import React, { useEffect, useState } from "react";
import ListFormComponent from "../../../../../components/generic/formbuilder/formslist/ListFormComponent";
import { notification } from "antd";
import ConfigurationConstants from "../../../../utils/configurationconstants";
import { useRecoilValue } from "recoil";
import { currentConfiguration } from "../../../../../service/memory/recoil/configurationstore";
import { useReadMemory } from "../../../hooks/useReadMemory";
import MemoryType from "../../../../../service/memory/enum/MemoryType";
import { useGetOrgIdentifier } from "../../../hooks/useGetOrgIdentifier";


/**
 * This component is for rendering the form builder menu
 */
const ListFormWrapper = () => {
  const configuration = useRecoilValue(currentConfiguration);
  const organizationIdentifier = useGetOrgIdentifier();
  const [bucketName, setBucketName] = useState("");
  const userJson = useReadMemory(MemoryType.USER);

  useEffect(() => {
    const bucketname = configuration[ConfigurationConstants.NIRAMAYA_FORMS_BUCKETNAME];
    setBucketName(bucketname?.value);
  }, [configuration]);

  const callback = (formData) => {
    notification.success({
      message: `Form Submitted Successfully`,
      placement: "bottomRight",
    });
  };

  return (
    <div id="list-form" style={{margin: "20px"}}>
      <ListFormComponent organizationId={organizationIdentifier} formsBucketName={bucketName} formSubmitCallback={callback} userIdentifier={userJson?.userIdentifier}/>
    </div>
  );
};

export default ListFormWrapper;
